function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7071 7.00002C22.0976 7.39054 22.0976 8.02371 21.7071 8.41423L16.1213 14L21.7071 19.5858C22.0976 19.9763 22.0976 20.6095 21.7071 21C21.3165 21.3905 20.6834 21.3905 20.2929 21L14.7071 15.4142L9.12128 21C8.73076 21.3905 8.0976 21.3905 7.70707 21C7.31655 20.6095 7.31655 19.9763 7.70707 19.5858L13.2929 14L7.70707 8.41423C7.31655 8.02371 7.31655 7.39055 7.70707 7.00002C8.0976 6.6095 8.73076 6.6095 9.12128 7.00002L14.7071 12.5858L20.2929 7.00001C20.6834 6.60949 21.3166 6.60949 21.7071 7.00002Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/x.7c45a53a.svg";
export { SvgComponent as ReactComponent };